import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    "id": "mac-group-001",
    "name": "MAC Group 001",
    "macList": [
      {
        "macAddress": "00:1A:2B:3C:4D:5E",
        "description": "Office Laptop"
      },
      // Generate 50 MAC addresses
      ...Array.from({ length: 50 }, (_, i) => {
        const mac = (i + 1).toString(16).padStart(2, '0').toUpperCase();
        return {
          "macAddress": `00:1A:2B:3C:4D:${mac}`,
          "description": `Device ${i + 1}`
        };
      })
    ]
  },
  {
    "id": "mac-group-002",
    "name": "MAC Group 002",
    "macList": [
      {
        "macAddress": "11:22:33:44:55:66",
        "description": "Guest Device"
      },
      // Generate 9
      ...Array.from({ length: 9 }, (_, i) => {
        const mac = (i + 1).toString(16).padStart(2, '0').toUpperCase();
        return {
          "macAddress": `11:22:33:44:55:${mac}`,
          "description": `Guest Device ${i + 1}`
        };
      })
    ]
  },
  {
    "id": "mac-group-003",
    "name": "MAC Group 003",
    "macList": [
      // Generate 23
      ...Array.from({ length: 23 }, (_, i) => {
        const mac = (i + 1).toString(16).padStart(2, '0').toUpperCase();
        return {
          "macAddress": `AA:BB:CC:DD:EE:${mac}`,
          "description": `Lab Device ${i + 1}`
        };
      })
    ]
  }
];

const initialState = {
  resource: 'macAddress',
  data: [...fakeData],
};

export const profileMacAddressSlice = createSlice({
  name: "profileMacAddress",
  initialState,
  reducers: {
    setMacAddressesData: (state, _) => {
      state.data = [...fakeData];
    },
    createMacAddressProfile: (state, action) => {
      const newMacAddresses = {
        id: `mac-group-${(state.data.length + 1).toString().padStart(3, '000')}`,
        name: action.payload.name,
        macList: action.payload.macList,
      };

      fakeData = [...fakeData, newMacAddresses];
      state.data.push(newMacAddresses);
    },
    updateMacAddressProfile: (state, action) => {
      const index = state.data.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        fakeData[index] = {
          ...fakeData[index],
          ...action.payload,
        };
        state.data[index] = {
          ...state.data[index],
          ...action.payload,
        };
      }
    },
    deleteMacAddressProfile: (state, action) => {
      state.data = state.data.filter(item => !action.payload.profileMacAddrsIds.includes(item.id));
      fakeData = fakeData.filter(item => !action.payload.profileMacAddrsIds.includes(item.id));
    },
  },
});

export const {
  setMacAddressesData,
  createMacAddressProfile,
  updateMacAddressProfile,
  deleteMacAddressProfile,
} = profileMacAddressSlice.actions;

export default profileMacAddressSlice.reducer;
